import {Component, Output, EventEmitter, Input, OnInit} from '@angular/core';
import {BackgroundBtnModel} from "../../models/background-btn-model";

@Component({
    selector: 'background-btn',
    templateUrl: './background-btn.component.html',
    styleUrls: ['./background-btn.component.css']
})
export class BackgroundBtnComponent implements OnInit{

    constructor(){
        this.inputClass = {};
    }

    @Input() private readonly inClass?: string[];

    public readonly inputClass: {[index: string]: boolean};

    ngOnInit(){
        this.generateClass();
    }

    //# add classes to button from input data
    private generateClass = (): any =>{
        this.inClass && this.inClass.length ? this.inClass.forEach(item => this.inputClass[item] = true) : null;
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/components/background-btn.component/background-btn.component.ts